import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyPlacement, CandidacyStatus, HttpResponse } from "@/types";

export function useRollbackPlacement() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      placementId,
      toCandidacyStatus,
    }: {
      placementId: number;
      toCandidacyStatus: CandidacyStatus;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/placements/${placementId.toString()}/rollback`;
      const res = await guacHttpClient.post<
        CandidacyPlacement,
        HttpResponse<CandidacyPlacement>,
        { toCandidacyStatus: CandidacyStatus }
      >(path, { toCandidacyStatus });

      return res.data;
    },
  });

  return mutation;
}
